export const authNoAccessProps = {
	label: 'Нет доступа',
	desc: 'Войдите на',
	labelSite: 'gorko.ru',
	linkSite: { href: 'https://gorko.ru', target: '_blank' },
	hint: 'Сейчас вы просматриваете gorko.ru как гость',
	labelReload: 'Перезагрузить страницу',
};
